import { implementCustomExpressions } from '../__generated/implementation.js';
import { FenixVariant, Legs3D, LegsAxel, LegsButterfly, LegsDiamond, LegsEbonu3DoubleEik, LegsEbonu3DoubleStaal, LegsEbonuEik, LegsEbonuStaal, LegsEbu, LegsElmoDouble, LegsFalke, LegsFly, LegsHarper, LegsLivio, LegsLivioSchuinEik, LegsLivioSchuinStaal, LegsMPootRecht, LegsMPootSchuin, LegsNovaroDoubleEik, LegsNovaroDoubleStaal, LegsOxford, LegsPapillon, LegsPapillonStrak, LegsRafino, LegsRobuDoubleEik, LegsRobuDoubleStaal, LegsTPoot, LegsTPootRonde, LegsTwist4 } from '../__generated/model/index.js';
const AVAILABLE_LEG_TYPES_OVAL = [
    Legs3D.type,
    LegsAxel.type,
    LegsButterfly.type,
    LegsDiamond.type,
    LegsEbonuEik.type,
    LegsEbonuStaal.type,
    LegsEbonu3DoubleEik.type,
    LegsEbonu3DoubleStaal.type,
    LegsEbu.type,
    LegsElmoDouble.type,
    LegsFalke.type,
    LegsFly.type,
    LegsHarper.type,
    LegsLivio.type,
    LegsLivioSchuinEik.type,
    LegsLivioSchuinStaal.type,
    LegsMPootRecht.type,
    LegsMPootSchuin.type,
    LegsNovaroDoubleEik.type,
    LegsNovaroDoubleStaal.type,
    LegsOxford.type,
    LegsPapillon.type,
    LegsPapillonStrak.type,
    LegsRafino.type,
    LegsRobuDoubleEik.type,
    LegsRobuDoubleStaal.type,
    LegsTPoot.type,
    LegsTPootRonde.type,
    LegsTwist4.type
];
export const topOvalExpressions = implementCustomExpressions({
    TopOval: {
        $objectName: (self)=>self.fenixVariant === FenixVariant.Birch ? 'FENIX_OVAAL_OVAL' : 'OVAAL_OVAL',
        $availableLegTypes: ()=>AVAILABLE_LEG_TYPES_OVAL
    }
});

//# sourceMappingURL=top-oval.js.map